/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

/* Style imports */
import "./styles.css";

/* Library imports */
import React, {Component} from "react";
import PropTypes from "prop-types";

/* Component imports */
import ContentLg from "../../../../ContentLg";
import ConstantsLg from "../../../../ConstantsLg";
import * as UtilityLg from "../../../../UtilityLg";
import TextboxLg from "../../../core/TextboxLg/TextboxLg";
import Gutter from "../../../core/Gutter/Gutter";
import LoginFooter from "../../../core/LoginFooter/LoginFooter";
import TextboxOutline from "../../../core/TextBoxOutline/TextBoxOutline";
/*** End Imports ***/

class ResetPasswordScreen extends Component {
    constructor(props){
        super(props);

        this.state = {
            password: ''
        };

        UtilityLg.bindThisToAll(this, "onTxtBxEmailChange", "validate");
    }

    onTxtBxEmailChange (value, respObj) {
        this.setState({
            email: value
        });
        this.props.onTxtBxPswdChange(value, respObj);
    }

    /* @public method */
    validate () {
        this.TxtBxPswdRef.validateManually();
    }

    onTxtBxEmailEditClick = () => {
        this.props.onEmailEditClick();
    };

    render () {
        const {
                email
            } = this.props
        ;

        return (

            <div className="recruiter-reset-password-screen">

                <div className="rec-rp-content" style={{width: '100%'}}>
                <div className="rec-lg-tbemail-wrpr" style= {{padding: '0 20px 20px 20px', position: 'relative'}}>
                    <TextboxOutline 
                            ref = { e => this.TxtBxEmailRef = e }
                            textBoxValue = {email}
                            pattern = {ConstantsLg.REGEX.EMAIL}
                            placeholder = {ContentLg.REC_EMAIL_PH}
                            // isRequired = {true}
                            onEnterClick = {this.onTxtBxEmailEnter}
                            maxLength = {50}
                            onChange = {this.onTxtBxEmailChange}
                            isDisabled = {true}
                        />
                        <img
                            className="btn-edit"
                            style = {{
                                top: '45px',
                                right: '30px'
                            }}
                            onClick={this.onTxtBxEmailEditClick}
                            src = {ConstantsLg.ICONS.EDIT_ICON_BLUE}
                        />
                    </div>
                    
                </div>

                <Gutter height={20}/>

                <Gutter height={40}/>

                <Gutter height={39}/>

                <div className="rrps-login-btn" onClick={this.props.onClickSendLink}>
                    <div className="rrps-login-btn-content">{ContentLg.BTN.SEND_EMAIL}</div>
                </div>
            </div>
        );
    }
}

ResetPasswordScreen.PropTypes = {
    email: PropTypes.string.isRequired
};

export default ResetPasswordScreen;


// WEBPACK FOOTER //
// ./src/components/ProfessionalLoginEmailMobile/components/ResetPasswordScreen/ResetPasswordScreen.js